import { FC, PropsWithChildren } from "react";

import { Box } from "@mui/material";

export const MinimalLayout: FC<PropsWithChildren<{ hideBackground?: boolean }>> = ({ children, hideBackground }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100dvh",
        backgroundColor: hideBackground ? undefined : "#ffffff",
      }}
    >
      {children}
    </Box>
  );
};
